export default defineNuxtPlugin((nuxtApp) => {
  const locale = useCookie('i18n_redirected')

  if (locale.value) {
    nuxtApp.vueApp.$nuxt.$i18n.setLocale(locale.value)
  }
})
